import { Pessoa } from './pessoa.model'

export class Automovel {
    descricao: string
    fabricante: number
    anoFabricacao: number
    anoModelo: number
    combustivel: number
    fipe: string
    chassi: string
    placa: string
    pctAjuste: number
    financiado: boolean
    tpUtilizacao: number
    categoriaTarifaria: number
    cepCirculacao: string
    cepPernoite: string
    tpLocalPernoite: number
    kmAnual: number
    passageiros: number
    portas: number
    jovemSexo: string
    cdAntiFurto: number
    idaVoltaEstudo: boolean
    idaVoltaTrabalho: boolean
    tpUtilizacaoComercial: number
    zeroKm: boolean
    jovemCondutor: boolean
    jovemIdade: number
    blindagemTem: boolean
    blindInstalValor: number
    tpUso: number
    garEstudoManha: boolean
    garEstudoNoite: boolean
    garEstudoTarde: boolean
    garTrabManha: boolean
    garTrabNoite: boolean
    garTrabTarde: boolean
    dataHoraSaidaLoja: string
    gasTem: boolean
    gasInstalValor: number
    tipoIsencao: number
    tipo: string
    residentes: [Pessoa?]
    condutores: [Pessoa?]
    proprietario: Pessoa

    constructor() {

        this.descricao = null;
        this.fabricante = null;
        this.anoFabricacao = null;
        this.anoModelo = null;
        this.combustivel = null;
        this.fipe = null;
        this.chassi = null;
        this.placa = null;
        this.pctAjuste = null;
        this.financiado = null;
        this.tpUtilizacao = null;
        this.categoriaTarifaria = null;
        this.cepCirculacao = null;
        this.cepPernoite = null;
        this.tpLocalPernoite = null;
        this.kmAnual = null;
        this.passageiros = null;
        this.portas = null;
        this.jovemSexo = null;
        this.cdAntiFurto = null;
        this.idaVoltaEstudo = null;
        this.idaVoltaTrabalho = null;
        this.tpUtilizacaoComercial = null;
        this.zeroKm = null;
        this.jovemCondutor = null;
        this.jovemIdade = null;
        this.blindagemTem = null;
        this.blindInstalValor = null;
        this.tpUso = null;
        this.garEstudoManha = null;
        this.garEstudoNoite = null;
        this.garEstudoTarde = null;
        this.garTrabManha = null;
        this.garTrabNoite = null;
        this.garTrabTarde = null;
        this.dataHoraSaidaLoja = null;
        this.gasTem = null;
        this.gasInstalValor = null;
        this.tipoIsencao = null;
        this.tipo = null;
        this.proprietario = null;
        this.residentes = [];
        this.condutores = [];
        
    }

}